import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import VueQRCodeComponent from 'vue-qr-generator';
Vue.component('qr-code', VueQRCodeComponent)

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, { vuetify });

import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);

var firebase = require("firebase/app");
require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");
import firebaseConfig from '@/config/firebase';
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const storage = firebase.storage();

export const auth = firebase.auth();

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged((user) => {
	if (user) {
		if (user.email !== 'itadmin@uebs.es'){
			firebase.auth().signOut()
		}
		store.dispatch('checkUser', { email: user.email, uid: user.uid }, { root: true })
	} else {
		store.dispatch('checkUser', null, { root: true })
	}

	new Vue({
		router,
		store,
		vuetify,
		render: h => h(App),
		mounted() {

		} // end mounted
	}).$mount('#app')


}) // end auth